export const WEBSITE = {
    DOMAIN: 'www.saversclubllc.com'
}